import React, { Component } from 'react'

// Full Time:
// 0-20 hours green
// >20 to 40 hours amber
// >40 hours red

// Part time:
// 0-40 hours green
// >40-60 hour amber
// >60 hours red

export default class InfoGraphic extends Component {
  constructor(props) {
    super(props)

    this.state = {
      height: 602,
      hoursToPix: 0,
      studyLoadConvert: {
        'FULL TIME': 60,
        'PART TIME': 80
      },
      scales: {
        'FULL TIME': {
          percent: [33.33, 66.66],
          display: [0, 20, 40]
        },
        'PART TIME': {
          percent: [50, 75],
          display: [0, 40, 60]
        }
      },
      colors: ['amber', 'red'],
      scaleDescription: [
        'Your commitments are approaching the limit of available hours most people need to succeed in their studies',
        'Your commitments have exceeded the limit of available hours most people need to succeed in their studies'
      ],
      warning: '',
      warningColor: '',
      sum: 0,
      loaded: false
    }
  }

  componentDidUpdate(props, prevState) {
    let studyLoad = this.getStudyLoad(props)
    let newState = {
      hoursToPix: this.state.height / this.state.studyLoadConvert[studyLoad],
      studyLoad: studyLoad,
      sum: this.calculateHours(props),
      loaded: true,
      ...this.hasWarningText(this.calculateHours(props))
    }
    
    if (prevState.hoursToPix !== newState.hoursToPix || prevState.studyLoad !== newState.studyLoad || prevState.sum !== newState.sum || prevState.warning !== newState.warning || prevState.warningColor !== newState.warningColor || prevState.loaded !== newState.loaded) {
      this.setState(newState)
    }
  }

  calculateHours(props) {
    let sum = 0
    if (
      props &&
      props.formAnswers &&
      props.formAnswers.hasOwnProperty('length')
    ) {
      sum = props.formAnswers.reduce((preVal, elem) => {
        let sliderValue = 0
        if (elem.hasOwnProperty('actualValue')) {
          sliderValue = parseInt(elem.actualValue, 10)
        }
        return preVal + sliderValue
      }, 0)
    }
    return sum
  }

  hasWarningText(sum) {
    let warningInfo = {
      warning: '',
      warningColor: '',
    }
    if (sum && this.state.studyLoad) {
      let range = Number.parseFloat(
        100 * (sum / this.state.studyLoadConvert[this.state.studyLoad])
      ).toFixed(2)

      if (
        range > this.state.scales[this.state.studyLoad].percent[0] &&
        range < this.state.scales[this.state.studyLoad].percent[1]
      ) {
        warningInfo = {
          warning: this.state.scaleDescription[0],
          warningColor: this.state.colors[0]
        }
        //return this.state.scaleDescription[0]
      } else if (range > this.state.scales[this.state.studyLoad].percent[1]) {
        warningInfo = {
          warning: this.state.scaleDescription[1],
          warningColor: this.state.colors[1]
        }
        //return this.state.scaleDescription[1]
      }
    }

    return warningInfo
  }
  

  calculateInfoGraphicOffset(hours, studyLoad) {
    if (hours > this.state.studyLoadConvert[studyLoad]) {
      return 0
    }
    return this.state.height - hours * this.state.hoursToPix + 'px'
  }

  getStudyLoad(props) {
    return props && props.hasOwnProperty('studyLoad') && props.studyLoad
        ? props.studyLoad
        : 'FULL TIME'
  }

  render() {
    let studyLoad = this.getStudyLoad(this.props)

    return (
      <div
        className={[
          'infographic-block',
          studyLoad.split(' ').join('-'),
          this.state.loaded ? 'active' : 'inactive'
        ].join(' ')}
      >
        <div>
          <h3>
            Your total activity time outside of uni: {this.state.sum} (hrs/wk)
          </h3>
        </div>
        <div
          className={[
            'infographic-wrapper',
            studyLoad.split(' ').join('-')
          ].join(' ')}
        >
          <div
            className={['infographic', studyLoad.split(' ').join('-')].join(
              ' '
            )}
          >
            <div
              className="scale-overlay"
              style={{
                height: this.calculateInfoGraphicOffset(
                  this.state.sum,
                  studyLoad
                )
              }}
            />
          </div>
          <span className="tick tick--bottom">0</span>
          <span className="tick tick--medium">
            {this.state.scales[studyLoad].display[1]}
          </span>
          <span className="tick tick--top">
            {this.state.scales[studyLoad].display[2]}
          </span>
        </div>
        {this.state.warning.length > 0 ? (
          <p className={this.state.warningColor}>{this.state.warning}</p>
        ) : null}
      </div>
    )
  }
}
